<template>
    <span class="hf-form-ui-form" >
<!--        <el-button type="primary" @click="$router.back(-1)"-->
        <!--                   size="mini">返回-->
        <!--        </el-button>-->
        <!--{{groupNamesShow}}-->
           <el-form :inline="true" class="demo-form-inline" size="mini" >
        <span :model="queryParamsCurrent"   ref="queryParamsCurrent" style="margin-top: 10px;"
              size="mini" v-if="loadSuccess" :inline="true">
            <span v-if="!isFieldGroup">
                <!--不带分组的-->
                 <span v-for="fieldItem,itemIndex in formuiFields">

                        <component v-bind:is="'FormUiQueryParamItem'"
                                   ref="FormUiQueryParamItem"
                                   v-bind:fieldItem="fieldItem"
                                   @setFieldValue="setFieldValue"
                        ></component>

                     </span>
            </span>
            <!--[{{isShowFieldGroupTitleFlag}}]-->
             <span v-if="isFieldGroup&&!isShowFieldGroupTitleFlag">
                 <span v-for="groupFormuiFields,groupNameKey in groupNames">

                          <!--<br/>-->

                        <span v-for="fieldItem,itemIndex in groupFormuiFields" v-if="fieldItem.groupName==groupNameKey&&itemIndex<groupNamesMoreLimit">

                        <component v-bind:is="'FormUiQueryParamItem'"
                                   ref="FormUiQueryParamItem"
                                   v-bind:fieldItem="fieldItem"
                                   @setFieldValue="setFieldValue"
                        ></component>

                        </span>

                     <!--{{groupNamesShow[groupNameKey]}}-->

                            <span v-for="fieldItem,itemIndex in groupFormuiFields" v-if="fieldItem.groupName==groupNameKey&&itemIndex>=groupNamesMoreLimit">

                            <component v-bind:is="'FormUiQueryParamItem'"
                                       ref="FormUiQueryParamItem"
                                       v-bind:fieldItem="fieldItem"
                                       @setFieldValue="setFieldValue"
                            ></component>
                            </span>

                </span>
             </span>

            <table class="param-table" v-if="isFieldGroup&&isShowFieldGroupTitleFlag" style="">
                <!--带分组的-->
                <tr v-for="groupFormuiFields,groupNameKey in groupNames" v-if="groupNameKey"><th v-if="groupNameKey"><b>{{(groupNameKey)}}</b>
                    <span class="el-icon-caret-right"></span></th>
                    <td :class="groupNameKey==''?'':'param-td'">



                    <div class="any">
                        <span v-for="fieldItem,itemIndex in groupFormuiFields" v-if="fieldItem.groupName==groupNameKey&&itemIndex<groupNamesMoreLimit">

                        <component v-bind:is="'FormUiQueryParamItem'"
                                   ref="FormUiQueryParamItem"
                                   v-bind:fieldItem="fieldItem"
                                   @setFieldValue="setFieldValue"
                        ></component>
                           </span>
                             <el-button type="text" class="showAll" @click="showAll(groupNameKey,true)" v-if="groupFormuiFields.length>groupNamesMoreLimit && !groupNamesShow[groupNameKey]">展开全部</el-button>
                            <el-button type="text" class="closeAll" @click="showAll(groupNameKey,false)" v-if="groupNamesShow[groupNameKey]">收起</el-button>

                    </div>
                        <!--{{groupNamesShow[groupNameKey]}}-->
                        <div class="more" v-if="groupNamesShow[groupNameKey]">
                            <span v-for="fieldItem,itemIndex in groupFormuiFields" v-if="fieldItem.groupName==groupNameKey&&itemIndex>=groupNamesMoreLimit">

                            <component v-bind:is="'FormUiQueryParamItem'"
                                       ref="FormUiQueryParamItem"
                                       v-bind:fieldItem="fieldItem"
                                       @setFieldValue="setFieldValue"
                            ></component>
                            </span>

                        </div>



                    </td>
                </tr>
            </table>
            <!--<div v-for="groupName in groupNames">-->
            <!--<span class=""></span>-->
            <!--{{groupName}}-->
            <!---->
            <!--</div>-->




        </span>

                <el-form-item>
                <el-button type="primary" @click="search()">查询</el-button>
            </el-form-item>
        </el-form>

    </span>
</template>

<script>
//  import util from '../../../../util/util'
  import mathUtil from './service/lib/math.js'
//  import router from '../../../../router'
  import formuiService from './service/formui/FormuiService.js'
  import formUiStyleSelect from './widget/FormUiStyleSelect.vue'
  import formUiForeignSelect from './widget/FormUiForeignSelect.vue'
//  import ImgUploadOss from '../../base/ImgUploadOss.vue'
  import FormUiQueryParamItem from './FormUiQueryParamItem.vue'
  import moment from 'moment'
  export default {
    name: 'UIForm_form',
    props: ['beanName','removeFileds','queryParams','isShowFieldGroupTitle'],
    components:{formUiStyleSelect,formUiForeignSelect,FormUiQueryParamItem,},
    data () {
      return {
        loadSuccess:false,
//        removeFileds:[],
        rules:{},
          queryParamsCurrent:{},
        queryParamsCurrentMoney:{},
        queryParamsCurrentTime:{},
        formuiFields: [], // 渠道类型
        isFieldGroup: false,//是否是带分组的
        groupNames:{'':''},
        groupNamesShow:{},
        groupNamesMoreLimit:4,
        isShowFieldGroupTitleFlag:true


      }
    },

    methods: {
      showAll(groupNameKey,flag){
        let that=this
//        alert(groupNameKey)
//          this.groupNamesShow[groupNameKey]=10
        this.$set(that.groupNamesShow,groupNameKey,flag)

      },
      uploadImg (newimagePath, newimageUrl,name) {
        this.queryParamsCurrent[name] = newimagePath
        this.queryParamsCurrent[name+'Url'] = newimageUrl
//          console.log('imagePath=' + imagePath)
//          console.log('imageUrl=' + imageUrl)
      },
      // 提交
//      submitForm () {
////          alert(11111)
////        let formName='queryParamsCurrent'
////      console.log(this.queryParams)
//        let that = this
//
//        this.$emit('updateQueryParams', this.queryParamsCurrent)
//
//        console.log(this.queryParamsCurrent)
//
//
//      },
      setFieldValue:function (key,value) {
          //所有子组件加载完成后 才允许使用子组件的赋值功能，否则初始话的时候会赋值错误数据
//          alert(loadSuccess)

          if(!this.loadSuccess){

              return;
          }
//          alert(key+''+value)
          if(value||value===''||value===0){
//              alert(key+'___'+value)
              this.$set(this.queryParamsCurrent,key,value)
          }else if(value===null) {
              this.$delete(this.queryParamsCurrent, key)
//              delete this.queryParamsCurrent[key]
          }else if(typeof(value) == "undefined"){
              this.$delete(this.queryParamsCurrent, key)
          }else{
              alert('无法处理的类型'+key)
          }


      },
      formatTime(date){
        return moment(date).format("YYYY-MM-DD HH:mm:ss");

      },
      setRules(){
        let that=this


        let fields=this.formuiFields
        for(var i=0;i<fields.length;i++){
          // alert(fields[i])
          if(fields[i].required==true){
//                  alert(fields[i].name)
            that.rules[fields[i].name]=[
              { required: true, message: '请输入'+fields[i].title, trigger: 'blur' }
            ]
          }

        }

//          return rules
      },
        search(){
            this.queryParamsCurrent.pageNo=0;
//            this.$router.push({
//                query: this.queryParamsCurrent
//            })
            this.$emit('updateQueryParams', this.queryParamsCurrent)
            this.$emit('search', this.queryParamsCurrent)
        }
    },
    created(){

      let that=this

        if(this.queryParams){
          this.queryParamsCurrent=this.queryParams
        }


      if(this.isShowFieldGroupTitle||this.isShowFieldGroupTitle===false){
        this.isShowFieldGroupTitleFlag=this.isShowFieldGroupTitle
      }
        ///默认值优先级别说明
        //由低到高，内置默认值，参数传值
        //

        //先从默认值中取
//        let queryP={}
//        if(this.queryParams){
//
//            let formKeys=Object.keys(this.queryParams);
//
//            for(var name of formKeys) {
////                alert(name)
//                if(this.queryParams[name]||this.queryParams[name]===''||this.queryParams[name]===0){
//                    queryP[name]=this.queryParams[name];
//                }
//            }
//        }
        //再从链接中参数中取
        let queryKeys=Object.keys(that.$route.query);
        for(var name of queryKeys) {
            if(that.$route.query[name]||that.$route.query[name]===''||that.$route.query[name]===0){
                var tmpval=that.$route.query[name]

//                this.$set(this.queryParamsCurrent,name,tmpval);
                this.queryParamsCurrent[name]=tmpval;
                this.queryParamsCurrent=this.queryParamsCurrent
            }
        }
        this.$emit('updateQueryParams', this.queryParamsCurrent)
        //将混合结果提交到浏览器参数中，给FormUiQueryParamItem解析使用
//        router.push({
//            query: queryP
//        })

        //更新form
//        alert('-2-')
//        this.$emit('updateQueryParams', this.queryParamsCurrent)
//        alert(queryP.isSendSmsCode)
//        alert(1)
        this.$nextTick(() => {
            //do somthing

            //所有子组件加载完成后，设置初始话完成标记
            that.loadSuccess=true
//            alert(123)
        });
    },
    mounted () {
//      console.log('-----------mounted-------------')

      let that=this






//return;
      let params={beanName:this.beanName}
      let formuiFieldList=[]
      formuiService.getFormuiForm(this,params,function (resp) {
//          groupNames

        for(let i=0;i<resp.formuiFields.length;i++){
//              alert(resp.formuiFields[i].name)
          if(resp.formuiFields[i].groupName){
            if(!that.groupNames[resp.formuiFields[i].groupName]){
              that.groupNames[resp.formuiFields[i].groupName]=[]

              //默认每个分组1个可见
//                      that.groupNamesShow[resp.formuiFields[i].groupName]=false

              that.$set(that.groupNamesShow,resp.formuiFields[i].groupName,false)
              that.isFieldGroup=true
            }
            that.groupNames[resp.formuiFields[i].groupName].push(resp.formuiFields[i])
          }
//              alert(resp.formuiFields[i].name+'_'+that.removeFileds)
          if(that.removeFileds.indexOf(resp.formuiFields[i].name)==-1){
            formuiFieldList.push(resp.formuiFields[i])

            let fieldItem=resp.formuiFields[i]

//                  alert(fieldItem.valueType)
            if(fieldItem.valueType=='DATETIME'||fieldItem.valueType=='DATE_BEGIN'||fieldItem.valueType=='DATE_END'){
//                      alert(that.queryParamsCurrent[fieldItem.name]+'__'+fieldItem.name)
              if(that.queryParamsCurrent[fieldItem.name]){

                that.$set(that.queryParamsCurrentTime, fieldItem.name, that.queryParamsCurrent[fieldItem.name])

              }

            }else if(fieldItem.valueType=='MONEY'){
//                      that.queryParamsCurrentMoney[fieldItem.name]=mathUtil.div(that.queryParamsCurrent[fieldItem.name],100)//
//                      alert(that.queryParamsCurrent[fieldItem.name])
//                      try{
              if(that.queryParamsCurrent[fieldItem.name]) {
                that.$set(that.queryParamsCurrentMoney, fieldItem.name, mathUtil.div(that.queryParamsCurrent[fieldItem.name], 100))
              }
//                      }catch(e){
//                          alert(e)
//                      }
//
//                      alert(fieldItem.name)
            }
          }else{
//                  alert(resp.formuiFields[i].name)
          }
        }

        that.formuiFields= formuiFieldList;

//          console.log(that.groupNames)



//          that.setRules()
//          setTimeout(function () {
//        that.loadSuccess=true
//          },1500)

      })


        //增加默认的分页参数
        if(that.$route.query.pageNo){
            that.setFieldValue('pageNo',parseInt(that.$route.query.pageNo))
        }

//        alert(that.$route.query.pageSize)
        if(that.$route.query.pageSize){
            that.setFieldValue('pageSize',parseInt(that.$route.query.pageSize))
        }



    },

    updated () {
//    console.log('-----------updated-------------')
    },

    destory () {

    }
  }
</script>

<style scoped="page">
    /*.param-table{width: 100%;background: #fff;background: #f0f3f5;}*/
    /*!*.param-table tr{display: inline;}*!*/
    /*.param-table{border-collapse:separate; border-spacing:0px;}*/
    /*.param-table td,.param-table th{ border-top: 10px solid #fff;border-left:1px solid  #fff;}*/
    /*.param-table td.param-td{ ;position: relative; vertical-align: middle;}*/
    /*.param-table th{width: 80px;vertical-align: top; line-height: 60px; color: #303133;font-size: 16px;}*/
    /*.param-table td{font-size: 14px;}*/
    /*.param-table td .showAll{ position: absolute; right: 10px; top:10px; color:}*/
    /*.param-table td .closeAll{ position: absolute; right: 10px; top:10px; color: #02A7F0;}*/
    /*.param-table td .any{padding-right: 70px;position: relative;padding: 0px 10px; }*/
    /*.param-table td .more{padding-right: 70px;;position: relative;padding: 0px 10px; }*/
    /*!*.param-table td span{display: inline-block;}*!*/
    /*!*.param-table td span label{display: inline-block;}*!*/
    /*.param-table tr.item-more td{background: none;}*/
</style>



// WEBPACK FOOTER //
// node_modules/formui-vue2-vistastory/FormUiQueryParam.vue